module.exports = __webpack_public_path__ + "static/media/nobound-logo-v2.4eed61c6.png";